// API utility functions for CSRF-protected requests

/**
 * Get CSRF token from meta tag
 */
export const getCSRFToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
};

/**
 * Make a fetch request with CSRF token included
 * @param {string} url - The URL to fetch
 * @param {object} options - Fetch options (method, body, etc.)
 * @returns {Promise<Response>}
 */
export const apiFetch = async (url, options = {}) => {
  const defaultHeaders = {
    'Accept': 'application/json',
  };

  // Add Content-Type for requests with body
  if (options.body && typeof options.body === 'string') {
    defaultHeaders['Content-Type'] = 'application/json';
  }

  // Add CSRF token for non-GET requests
  const method = (options.method || 'GET').toUpperCase();
  if (method !== 'GET' && method !== 'HEAD') {
    defaultHeaders['X-CSRF-Token'] = getCSRFToken();
  }

  return fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  });
};

/**
 * DELETE request helper
 */
export const apiDelete = (url, options = {}) => {
  return apiFetch(url, { ...options, method: 'DELETE' });
};

/**
 * POST request helper
 */
export const apiPost = (url, data, options = {}) => {
  return apiFetch(url, {
    ...options,
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * PATCH request helper
 */
export const apiPatch = (url, data, options = {}) => {
  return apiFetch(url, {
    ...options,
    method: 'PATCH',
    body: JSON.stringify(data),
  });
};
